import { format, isToday } from "date-fns";
import { enUS } from "date-fns/locale";

export default function formatDate(date: Date) {
    const formattedDate = format(date, "MMMM d, yyyy", {
      locale: enUS, // Correct locale usage
    });
  
    const isTodayDate = isToday(date);
    const todayString = isTodayDate ? " - Today" : "";
    const dayOfWeekString = isTodayDate
      ? ""
      : ` - ${format(date, "EEEE", { locale: enUS })}`;
  
    return `${formattedDate}${todayString}${dayOfWeekString}`;
  }

export function formatTime(date: Date) {
    const formattedTime = date.toLocaleTimeString("en-us", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
    return formattedTime;
  }
